module.exports = __webpack_public_path__ + "img/org-logo.e48d032a.png";